////ORIGINAL////
// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// import Header from './components/Header';
// import Hero from './components/Hero';
// import InstallationServices from './components/InstallationServices';
// import InstallGallery from './components/InstallGallery';
// import ServicesOverview from './components/ServicesOverview';
// import TrustMetrics from './components/TrustMetrics';
// import TacomaPartsShowcase from './components/TacomaPartsShowcase';
// import EmailSignup from './components/EmailSignup';
// import Testimonials from './components/Testimonials';
// import Footer from './components/Footer';
// import StickyCTABar from './components/StickyCTABar';

// import About from './pages/About';
// import PrivacyPolicy from './pages/PrivacyPolicy';
// import TermsOfService from './pages/TermsOfService';
// import CookiePolicy from './pages/CookiePolicy';
// import ShopLocation from './pages/ShopLocation';

// // ✅ New contact page
// import Contact from './pages/Contact';

// import ShopPage from './pages/ShopPage';
// import CartPage from './pages/CartPage';

// // ✅ Use the headless product detail
// import ProductDetail from './components/ProductDetail';

// // ✅ Import CartProvider
// import { CartProvider } from './context/CartContext';

// // ✅ Home page composition
// const HomePage = () => {
//   return (
//     <>
//       <Hero />
//       <InstallationServices />
//       <InstallGallery />
//       <ServicesOverview />
//       <TrustMetrics />
//       <TacomaPartsShowcase />
//       <EmailSignup />
//       <Testimonials />
//     </>
//   );
// };

// function App() {
//   return (
//     <Router>
//       {/* 👇 Wrap everything in CartProvider */}
//       <CartProvider>
//         <div className="App min-h-screen bg-charcoal">
//           <Header />

//           <Routes>
//             <Route path="/" element={<HomePage />} />
//             <Route path="/about" element={<About />} />
//             <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//             <Route path="/terms-of-service" element={<TermsOfService />} />
//             <Route path="/cookie-policy" element={<CookiePolicy />} />
//             <Route path="/shop-location" element={<ShopLocation />} />

//             {/* ✅ Contact page route */}
//             <Route path="/contact" element={<Contact />} />

//             {/* ✅ Headless shop + cart */}
//             <Route path="/shop" element={<ShopPage />} />
//             <Route path="/product/:handle" element={<ProductDetail />} />
//             <Route path="/cart" element={<CartPage />} />
//           </Routes>

//           <Footer />
//           <StickyCTABar />
//         </div>
//       </CartProvider>
//     </Router>
//   );
// }

// export default App;
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import InstallationServices from "./components/InstallationServices";
import InstallGallery from "./components/InstallGallery";
import ServicesOverview from "./components/ServicesOverview";
import TrustMetrics from "./components/TrustMetrics";
import TacomaPartsShowcase from "./components/TacomaPartsShowcase";
import EmailSignup from "./components/EmailSignup";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import StickyCTABar from "./components/StickyCTABar";
import DirectSupportBubble from "./components/DirectSupportBubble";
import About from "./pages/About";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";
import ShopLocation from "./pages/ShopLocation";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Inbox from "./pages/Inbox";
import ShopPage from "./pages/ShopPage";
import CartPage from "./pages/CartPage";
import ProductDetail from "./components/ProductDetail";
import ScrollToTop from "./components/ScrollToTop";
import { CartProvider } from "./context/CartContext";
import bgtrace from "./assets/bgtrace1.jpeg";

// ✅ Home page composition
const HomePage = () => {
  return (
    <>
      {/* 🌆 Hero Section (keeps its original dark background) */}
      <Hero />

      {/* 🏞️ Global topo background for white sections */}
      <div
        className="
          bg-[url('./assets/bgtrace1.jpeg')]
          bg-center
          bg-no-repeat
          sm:bg-fixed
          topo-bg-responsive
          py-10
        "
        style={{
          backgroundImage: `url(${bgtrace})`,
          backgroundPosition: "center",
        }}
      >
        {/* ✅ These components now share the topo background */}
        <InstallGallery />
        <InstallationServices />
        <ServicesOverview />
        <TrustMetrics />
        <TacomaPartsShowcase />
        <EmailSignup />
        <Testimonials />
      </div>
    </>
  );
};

// ✅ Main App with routes
function App() {
  return (
    <Router>
      <ScrollToTop />
      <CartProvider>
        <div className="App min-h-screen bg-charcoal">
          {/* 🌐 Header is always visible */}
          <Header />

          {/* 🗺️ Routes */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/shop-location" element={<ShopLocation />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/inbox" element={<Inbox />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/product/:handle" element={<ProductDetail />} />
            <Route path="/cart" element={<CartPage />} />
          </Routes>

          {/* 🌐 Global Footer & Floating Elements */}
          <Footer />
          <StickyCTABar />
          <DirectSupportBubble />
        </div>
      </CartProvider>
    </Router>
  );
}

export default App;
